import gql from 'graphql-tag';

export default {
	logoutUser: gql`
		mutation logoutUser($username: String!, $dataname: String!) {
			logout(username: $username, dataname: $dataname) {
				dataname
				user {
					username
				}
			}
		}
	`,
	updateUserChainLocation: gql`
		mutation updateUserChainLocation($input: UserChainLocationInput!) {
			updateUserChainLocation(input: $input) {
				token
				dataname
				user {
					email
					active
					firstName
					lastName
					dataname
					decimalChar
					accessLevel
					accessWhiteList
					decimalPlaces
					deleted
					lavuAdmin
					restaurantId
					locationId
					monetarySymbol
					originalDataname
					position
					primaryCurrencyCode
					restrictedUser
					thousandsChar
					username
					isNewControlPanelActive
					trialInfo {
						status
						daysRemaining
					}
					lavuId
					newReports
					hasLavuEnterpriseModuleEnabled
				}
			}
		}
	`,
};
